var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTreeFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5L20 8C20 7.44772 19.5523 7 19 7L11.4142 7C11.149 7 10.8946 6.89464 10.7071 6.70711L9.29289 5.29289C9.10536 5.10536 8.851 5 8.58579 5L5 5C4.44772 5 4 5.44771 4 6L4 17C4 17.5523 4.44772 18 5 18L12 18",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81063 10.7575C5.92193 10.3123 6.32191 10 6.78078 10H20.7192C21.3698 10 21.8472 10.6114 21.6894 11.2425L20.1894 17.2425C20.0781 17.6877 19.6781 18 19.2192 18H5.28078C4.6302 18 4.15285 17.3886 4.31063 16.7575L5.81063 10.7575Z",
    stroke: "#CCCFD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreeFolderOpen);
export default __webpack_public_path__ + "static/media/icon-tree-folder-open.ad4b49edef30ab2aba73ddf63af7915d.svg";
export { ForwardRef as ReactComponent };